import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.service-slider__splide' ).length ) {
        const sliders = new Map();

        $( '.service-slider__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 3,
            focus: 'center',
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
                gap: '1rem',
              },
            },
          } );

          const splideNav = slider.root.querySelector( '.service-slider__splide-nav' );

          slider.on( 'overflow', function( isOverflow ) {
            slider.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
              focus: 0,
            };
            if ( !isOverflow ) {
              splideNav.style.display = 'none';
            } else {
              splideNav.style.display = 'flex';
            }
          } );

          const progressBar = slider.root.querySelector( '.service-slider__progress-bar' );
          const progressAmount = slider.root.querySelector( '.service-slider__progress-amount' );

          if ( progressBar ) {
            slider.on( 'mounted refresh move', function( newIndex, prevIndex, destIndex ) {
              const end = slider.Components.Controller.getEnd() + 1;
              const slideCount = slider.Components.Slides.getLength();
              const rate = Math.min( ( slider.index + 1 ) / end, 1 );
              progressBar.style.width = String( 100 * rate ) + '%';

              /* updates sr-only text of progress bar */
              if ( slideCount >= 3 ) {
                $( progressAmount ).text( `${slider.index + 3} of ${slideCount} cards` );
              } else {
                $( progressAmount ).text( `${slideCount} of ${slideCount} cards` );
              }
            } );
          }

          slider.mount();

          sliders.set( element.dataset.tabId, slider );
        } );

        $( '.featured-services-tabs' ).each( function() {
          const component = this;
          const form = component.querySelector( '.js-featured-services-tabs__form' );

          if ( !form ) {
            return;
          }

          let currentSlider = component.querySelector( '.featured-services-tabs__tab-content.is-open' )?.id;

          $( form ).on( 'change', function( event ) {
            const updatedSlider = event.target.value;
            const currentPanel = currentSlider ? component.querySelector( `#${currentSlider}` ) : null;
            const updatedPanel = component.querySelector( `#${updatedSlider}` );

            if ( !updatedPanel || updatedSlider === currentSlider ) {
              return;
            }

            currentPanel?.classList.remove( 'is-open' );
            currentPanel?.setAttribute( 'aria-hidden', 'true' );
            updatedPanel.classList.add( 'is-open' );
            updatedPanel.setAttribute( 'aria-hidden', 'false' );

            currentSlider = updatedSlider;

            form.querySelector( '.featured-services-tabs__select' ).value = currentSlider;
            const matchingRadio = form.querySelector( `.featured-services__radio-input[value="${currentSlider}"]` );
            if ( matchingRadio ) {
              matchingRadio.checked = true;
            }

            window.requestAnimationFrame( () => {
              sliders.get( currentSlider )?.refresh();
            } );

            const selectedTitle = form.querySelector( `.featured-services-tabs__select option[value="${currentSlider}"]` )?.textContent.trim();
            const announcement = component.querySelector( '.featured-services-tabs__announcement' );
            if ( announcement && selectedTitle ) {
              announcement.textContent = `${selectedTitle} slider is displayed`;
            }
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'service-slider', COMPONENT );
} )( app );
